/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MediaListOverview } from './MediaListOverview';
import {
    MediaListOverviewFromJSON,
    MediaListOverviewFromJSONTyped,
    MediaListOverviewToJSON,
} from './MediaListOverview';

/**
 * メディアリストの総数と指定範囲のメディアリスト一覧
 * @export
 * @interface GetMediaListsResponse
 */
export interface GetMediaListsResponse {
    /**
     * メディアリストの総数（fieldsで指定された時だけ）
     * @type {number}
     * @memberof GetMediaListsResponse
     */
    totalCount?: number;
    /**
     * 指定範囲のメディアリスト一覧
     * @type {Array<MediaListOverview>}
     * @memberof GetMediaListsResponse
     */
    mediaLists: Array<MediaListOverview>;
}

/**
 * Check if a given object implements the GetMediaListsResponse interface.
 */
export function instanceOfGetMediaListsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mediaLists" in value;

    return isInstance;
}

export function GetMediaListsResponseFromJSON(json: any): GetMediaListsResponse {
    return GetMediaListsResponseFromJSONTyped(json, false);
}

export function GetMediaListsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMediaListsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'mediaLists': ((json['media_lists'] as Array<any>).map(MediaListOverviewFromJSON)),
    };
}

export function GetMediaListsResponseToJSON(value?: GetMediaListsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'media_lists': ((value.mediaLists as Array<any>).map(MediaListOverviewToJSON)),
    };
}

